import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const NodePersonDetail = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const phoneNumber = entity.getIn(['field_phone_number', 0, 'value']);
  const emailAddress = entity.getIn(['field_e_mailadres', 0, 'value']);
  const avatar = entity.getIn(['field_image', 0, 'styles', 'medium']);
  const { t } = useTranslation();

  return (
    <article className="NodePerson">
      {/* TODO: Make i18n string */}
      <div className="NodePerson__intro">
        <h4>Contact</h4>
        <WysiwygField
          property="schema:text"
          html={body}
          className="NodePerson__body"
        />
      </div>
      <div className="NodePerson__person">
        <div className="NodePerson__person__image">
          <Image src={avatar} />
        </div>
        <div className="NodePerson__person__info">
          <div className="NodePerson__person__info__title">
            {title}
          </div>
          <div className="NodePerson__person__info__phone icon-before icon-phone icon-variant-2">
            <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
          </div>
          <div className="NodePerson__person__info__email icon-before icon-mail icon-variant-2">
            <a href={`mailto:${emailAddress}`}>{t('send_email')}</a>
          </div>
        </div>
      </div>

    </article>
  );
};

export default NodePersonDetail;
